import { PasskeyLoginErrorService } from './passkey-login-error.service';
import * as i0 from "@angular/core";
import * as i1 from "./passkey-login-error.service";
function PasskeyLoginErrorComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 0)(1, "p", 1);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx);
} }
export class PasskeyLoginErrorComponent {
    constructor(passkeyLoginErrorService) {
        this.passkeyLoginErrorService = passkeyLoginErrorService;
        this.errorMessage = this.passkeyLoginErrorService.errorMessage;
    }
}
PasskeyLoginErrorComponent.ɵfac = function PasskeyLoginErrorComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PasskeyLoginErrorComponent)(i0.ɵɵdirectiveInject(i1.PasskeyLoginErrorService)); };
PasskeyLoginErrorComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: PasskeyLoginErrorComponent, selectors: [["ycn-passkey-login-error"]], standalone: false, decls: 1, vars: 1, consts: [[1, "feedback", "feedback-invalid"], [1, "msg"]], template: function PasskeyLoginErrorComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, PasskeyLoginErrorComponent_Conditional_0_Template, 3, 1, "div", 0);
    } if (rf & 2) {
        let tmp_0_0;
        i0.ɵɵconditional((tmp_0_0 = ctx.errorMessage()) ? 0 : -1, tmp_0_0);
    } }, encapsulation: 2 });
